/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const RichMediaIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="RichMediaIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path
                d="M3 2.5C3 2.22386 3.22386 2 3.5 2H6V3H4V8.5H3.98228C3.86097 9.34807 3.13162 10 2.25 10C1.2835 10 0.5 9.2165 0.5 8.25C0.5 7.2835 1.2835 6.5 2.25 6.5C2.5184 6.5 2.77269 6.56042 3 6.66841V2.5Z"
                fill="currentColor"
              />
              <path
                d="M10.5 9.5C11.0523 9.5 11.5 9.05228 11.5 8.5C11.5 7.94772 11.0523 7.5 10.5 7.5C9.94771 7.5 9.5 7.94772 9.5 8.5C9.5 9.05228 9.94771 9.5 10.5 9.5Z"
                fill="currentColor"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 8.5C6 6.01472 8.01472 4 10.5 4C12.9853 4 15 6.01472 15 8.5C15 9.7425 14.4958 10.8682 13.682 11.682L10.8536 14.5104C10.7598 14.6042 10.6326 14.6569 10.5 14.6569C10.3674 14.6569 10.2402 14.6042 10.1464 14.5104L7.31802 11.682C6.50423 10.8682 6 9.7425 6 8.5ZM10.5 5C8.567 5 7 6.567 7 8.5C7 9.46664 7.3912 10.341 8.02513 10.9749L10.5 13.4497L12.9749 10.9749C13.6088 10.341 14 9.46664 14 8.5C14 6.567 12.433 5 10.5 5Z"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

RichMediaIcon.tags = [
  'note',
  'location',
  'music',
  'map',
  'audio',
  'pin',
  'playlist',
];

RichMediaIcon.category = 'General Icons';

RichMediaIcon.iconSize = 16;
